import React, { useContext, useState } from 'react';
import { Button, Dropdown } from 'antd';
import { PlusOutlined, CalendarOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { UserContext } from '../App';
import AbsenceCreateModal from './AbsenceCreateModal';
import HelpdeskCreateModal from './HelpdeskCreateModal';

// + Create in the top bar, before My Hub: the same popups as My Absence
// Notifications' Submit Absence and My HelpDesk's New Ticket.
export default function QuickCreate() {
  const currentUser = useContext(UserContext);
  const navigate = useNavigate();
  const [absenceOpen, setAbsenceOpen] = useState(false);
  const [ticketOpen, setTicketOpen] = useState(false);
  const [filterOpts, setFilterOpts] = useState(null);

  const openTicket = () => {
    if (filterOpts) { setTicketOpen(true); return; }
    api.get('/api/helpdesk/filter-options')
      .then((r) => setFilterOpts(r.data))
      .catch(() => setFilterOpts({ teams: [], users: [] }))
      .finally(() => setTicketOpen(true));
  };

  const items = [
    // A View Only user (Admin > Users) does not submit absences.
    ...(!currentUser?.IsViewOnly ? [{ key: 'absence', icon: <CalendarOutlined />, label: 'Absence Notification',
      onClick: () => setAbsenceOpen(true) }] : []),
    { key: 'ticket', icon: <CustomerServiceOutlined />, label: 'HelpDesk Ticket', onClick: openTicket },
  ];

  return (
    <>
      <Dropdown menu={{ items }} trigger={['click']} placement="bottomLeft">
        <Button type="primary" icon={<PlusOutlined />} style={{ flexShrink: 0 }}>Create</Button>
      </Dropdown>
      <AbsenceCreateModal
        open={absenceOpen}
        userId={currentUser?.ID}
        currentUser={currentUser}
        navigate={navigate}
        onClose={() => setAbsenceOpen(false)}
      />
      <HelpdeskCreateModal open={ticketOpen} onClose={() => setTicketOpen(false)} filterOpts={filterOpts || { teams: [], users: [] }} />
    </>
  );
}
